import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv',
  standalone: true,
  imports: [CommonModule],
  templateUrl:
    './snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv.component.html',
  styleUrl:
    './snelstart-venture-fiscaal-feature-tekst-loon-reiskostenOv.component.scss',
})
export class SnelstartVentureFiscaalFeatureTekstLoonReiskostenOvComponent {}
